export default __webpack_public_path__ + "static/media/tracking-transportation-ico.c8601214.svg";